import { render, staticRenderFns } from "./create-products.vue?vue&type=template&id=62638c4c&"
import script from "./create-products.vue?vue&type=script&lang=js&"
export * from "./create-products.vue?vue&type=script&lang=js&"
import style0 from "./create-products.vue?vue&type=style&index=0&id=62638c4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports